import { useState } from 'react';

import { GetByZipCode } from 'services/perfil/getByZipCode';
import { GetPerfilUser } from 'services/perfil/getPerfilUser';
import { GetRelationship } from 'services/perfil/getRelationship';
import { GetCustomerForEdit } from 'services/perfil/getCustomerForEdit';
import { GetPlatformsWithPolicy } from 'services/perfil/getPlatformsWithPolicy';

import { PostPolicyPdfRequest } from 'services/perfil/postPolicyPdfRequest';
import { PostEditCustomerAppData } from 'services/perfil/postEditCustomerAppData';
import { PostEditCustomerAppPhone } from 'services/perfil/postEditCustomerAppPhone';
import { PostEditCustomerAppAccess } from 'services/perfil/postEditCustomerAppAccess';
import { PostEditCustomerAppAddress } from 'services/perfil/postEditCustomerAppAddress';
import { PostEditCustomerAppEmergencyContacts } from 'services/perfil/postEditCustomerAppEmergencyContacts';

import { ParamsDataCustomerForEdit, ParamsDataPerfilUser, ParamsBodyEditCustomerAppData, ParamsBodyEditCustomerAppAccess, ParamsBodyEditCustomerAppPhone, ParamsBodyByZipCode, ParamsBodyEditCustomerAppAddress, ParamsDataGetRelationship, ParamsBodyEditCustomerAppEmergencyContacts, ParamsDataPlatformsWithPolicy, ParamsUpdatePerfil, ParamsDataPolicyPdfRequest, ParamsBodyPolicyPdfRequest } from 'utils/typeServices';

const useMyPerfil = () => {
    const [updatePerfil, setUpdatePerfil] = useState<ParamsUpdatePerfil>({ type: 'default', result: false, error_msg: '', flPerfil: false });
    const [dataByZipCode, setDataByZipCode] = useState<ParamsBodyByZipCode | false>();
    const [dataPerfilUser, setDataPerfilUser] = useState<ParamsDataPerfilUser | false>();
    const [dataCustomerForEdit, setDataCustomerForEdit] = useState<ParamsDataCustomerForEdit>();
    const [dataRelationship, setDataRelationship] = useState<Array<ParamsDataGetRelationship>>();
    const [dataPlatformsWithPolicy, setDataPlatformsWithPolicy] = useState<Array<ParamsDataPlatformsWithPolicy> | false>();
    const [dataPolicyPdfRequest, setDataPolicyPdfRequest] = useState<ParamsDataPolicyPdfRequest | false>();

    const handleClearPerfil = () => {
        handleResetUpdatePerfil();
        setDataByZipCode(undefined);
        setDataPerfilUser(undefined);
        setDataCustomerForEdit(undefined);
        setDataRelationship([]);
        setDataPlatformsWithPolicy(undefined);
    }

    const handleResetUpdatePerfil = () => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
    }

    const handleGetCustomerForEdit = async ({ token }: { token: string }) => {
        const { data } = await GetCustomerForEdit({ token });

        if (data) {
            setDataCustomerForEdit(data);
        }
    }

    const handleGetPerfilUser = async ({ token, nrPlatform }: { token: string, nrPlatform: number }) => {
        setDataPerfilUser(undefined);
        const { data } = await GetPerfilUser({ token, nrPlatform });

        if (data) {
            setDataPerfilUser(data);
        } else {
            setDataPerfilUser(false);
        }
    }

    const handlePostEditCustomerAppData = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppData }) => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
        const { data } = await PostEditCustomerAppData({ token, body });

        if (data) {
            setUpdatePerfil({ type: 'generalData', result: true, error_msg: '' });
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        } else {
            setUpdatePerfil({ type: 'generalData', result: false, error_msg: '' });
        }
    }

    const handlePostEditCustomerAppAccess = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppAccess }) => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
        const { data, error_msg } = await PostEditCustomerAppAccess({ token, body });

        if (data) {
            setUpdatePerfil({ type: 'accessData', result: true, error_msg: '' });
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        } else {
            error_msg ? setUpdatePerfil({ type: 'accessData', result: false, error_msg: error_msg }) : setUpdatePerfil({ type: 'accessData', result: false, error_msg: '' })
        }
    }

    const handlePostEditCustomerAppPhone = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppPhone }) => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
        const { data } = await PostEditCustomerAppPhone({ token, body });

        if (data) {
            setUpdatePerfil({ type: 'phoneContact', result: true, error_msg: '' });
            handleGetCustomerForEdit({ token: token });
        } else {
            setUpdatePerfil({ type: 'phoneContact', result: false, error_msg: '' });
        }
    }

    const handleGetByZipCode = async ({ token, cep, indexId }: { token: string, cep: string, indexId?: number }) => {
        setDataByZipCode(undefined);
        const { data } = await GetByZipCode({ token, cep });
        if (data) {
            indexId !== undefined ? setDataByZipCode({ ...data, cep, indexId: indexId }) : setDataByZipCode(data);
        } else {
            setDataByZipCode(false);
        }
    }

    const handlePostEditCustomerAppAddress = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppAddress }) => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
        const { data } = await PostEditCustomerAppAddress({ token, body });

        if (data) {
            if (data === "Foi aberto uma solicitação, nossa central de atendimento entrará em contato.") {
                setUpdatePerfil({ type: 'billingAddress', result: true, showModal: true, error_msg: '', flPerfil: body.flAtualizaPerfil });
            } else {
                setUpdatePerfil({ type: 'billingAddress', result: true, error_msg: '', flPerfil: body.flAtualizaPerfil });
            }
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        } else {
            setUpdatePerfil({ type: 'billingAddress', result: false, error_msg: '' });
        }
    }

    const handleGetRelationship = async ({ token }: { token: string }) => {
        const { data } = await GetRelationship({ token });

        if (data) {
            setDataRelationship(data);
        }
    }

    const handlePostEditCustomerAppEmergencyContacts = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppEmergencyContacts }) => {
        setUpdatePerfil({ type: 'default', result: false, error_msg: '' });
        const { data } = await PostEditCustomerAppEmergencyContacts({ token, body });

        if (data) {
            setUpdatePerfil({ type: 'emergencyContact', result: true, error_msg: '' });
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        } else {
            setUpdatePerfil({ type: 'emergencyContact', result: false, error_msg: '' });
        }
    }

    const handleGetPlatformsWithPolicy = async ({ token }: { token: string }) => {
        setDataPlatformsWithPolicy(undefined);
        const { data } = await GetPlatformsWithPolicy({ token });

        if (data) {
            setDataPlatformsWithPolicy(data);
        } else {
            setDataPlatformsWithPolicy(false);
        }
    }

    const handlePostPolicyPdfRequest = async ({ token, body }: { token: string, body: ParamsBodyPolicyPdfRequest }) => {
        const { data } = await PostPolicyPdfRequest({ token, body });

        if (data) {
            setDataPolicyPdfRequest(data);
        } else {
            setDataPolicyPdfRequest(false);
        }
    }

    return { dataCustomerForEdit, dataPerfilUser, dataByZipCode, dataRelationship, dataPlatformsWithPolicy, updatePerfil, dataPolicyPdfRequest, handleGetCustomerForEdit, handleGetPerfilUser, handlePostEditCustomerAppData, handlePostEditCustomerAppAccess, handlePostEditCustomerAppPhone, handleGetByZipCode, handlePostEditCustomerAppAddress, handleGetRelationship, handlePostEditCustomerAppEmergencyContacts, handleGetPlatformsWithPolicy, handleClearPerfil, handleResetUpdatePerfil, handlePostPolicyPdfRequest };
}

export default useMyPerfil;